import React from "react";
import PropTypes from 'prop-types';
import { navigate } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image";

const colourVariants = {
  fill: {
    plum: 'fill-plum-700',
    blue: 'fill-blue-700',
    orange: 'fill-orange-700',
    moon: 'fill-moon-700',
  },
    fill500: {
    plum: 'fill-plum-500',
    blue: 'fill-blue-500',
    orange: 'fill-orange-500',
    moon: 'fill-moon-500',
  },
    border: {
    plum: 'border-plum-700',
    blue: 'border-blue-700',
    orange: 'border-orange-700',
    moon: 'border-moon-700',
  },
}

export default function MainPageHeader({title, image, gatsbyImage, backLink, backLabel, iconAccent, accentColour, small}) {

    const accentIcons = {
        tableau : <div className="absolute left-[40px] md:left-[220px] -top-[350px] ">
            <svg className="ml-16 h-[50px] w-[50px] md:h-[75px] md:w-[75px]" xmlns="http://www.w3.org/2000/svg" width="75" height="75" viewBox="0 0 75 75" fill="none">
                <path d="M31.1769 16.8587V33.7174H0V46.2826H31.1769V80H43.8119V46.2826H75V33.7174H43.8119V0H31.1769V16.8587Z" className={`${colourVariants['fill'][accentColour]}`}/>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="40" viewBox="0 0 38 40" fill="none">
                <path d="M15.7963 8.42935V16.8587H0V23.1413H15.7963V40H22.198V23.1413H38V16.8587H22.198V0H15.7963V8.42935Z" className={`${colourVariants['fill'][accentColour]}`}/>
            </svg>
            <svg className="mt-28 md:mt-24 ml-32" xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none">
                <path d="M7.89814 4.21468V8.42935H0V11.5706H7.89814V20H11.099V11.5706H19V8.42935H11.099V0H7.89814V4.21468Z" fill="white"/>
            </svg>
        </div> ,
        alteryx : <div className="absolute left-[220px] -top-[350px] ">
            <svg className="ml-16" xmlns="http://www.w3.org/2000/svg" width="75" height="75" viewBox="0 0 500 500" fill="none" >
            <path className={`${colourVariants['fill'][accentColour]}`} d="M297.9,393.7l-1.6,1.2l-1.7,1c-29.8,20.6-74.3,34.4-110.8,34.4h0c-53.5-1.2-73-20.1-74.1-71.6
                c1.2-59.3,21-77.6,87.8-81.8l92.2-4.3l4.1-0.2l4-0.1V393.7z M465.9,422.9c-3-10-11.3-16.1-21.4-16.1c-2.7,0.1-5.2,0.3-8.4,1
                c-14.3,3.4-22.2,4.5-33.2,5.3c-20.9,1-24.6-7.1-25.9-30.6V61.4c-0.6-7.4-4.5-14.8-10.2-19.3l-2.1-1.3c-0.7-0.5-1.3-1.2-2.2-1.6
                C345,28.9,316,20.6,291.4,14.4l-1.8-0.5C260.3,6.8,228,3.1,196,3.1c-18.8,0-35.7,1.4-42.5,2.3c-14.1,1.4-52,7.7-64.7,12
                c-3.7,1.2-15.7,6.9-16.1,18.2c0.2,5.9,6.8,24.6,6.8,24.6c4.3,13.1,8.9,16.3,17.2,18c6.7,0.8,21-2.3,30.6-3.9
                c24.7-4.6,40.9-6.3,52.5-6.4c15-0.2,33.8-0.4,55.9,2.7c41.9,6.4,58.1,19.3,58.1,19.3v124.7l-3.7,0.1l-89.6,2.2
                C80.8,220.8,25.3,268.3,26.1,364c-0.2,43.5,13.4,78.3,39.4,100.9c24.1,21.2,59.5,32.3,102,32.3h0.2c48.8,0,90.9-15.1,131.8-47.5
                l3.9-3l2,4.5c9.8,21.7,26.6,35.7,49.7,41.6c10.3,2.9,22.1,4.4,37.2,4.4c3.9,0,7.8-0.2,11.2-0.6c13.7-1.9,31.9-4.3,52.1-13.9
                c11.1-5.3,19-11.8,18.4-23.5C473.6,448.9,465.9,422.9,465.9,422.9"/>
            </svg>
            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 500 500" fill="none" >
            <path className={`${colourVariants['fill'][accentColour]}`} d="M297.9,393.7l-1.6,1.2l-1.7,1c-29.8,20.6-74.3,34.4-110.8,34.4h0c-53.5-1.2-73-20.1-74.1-71.6
                c1.2-59.3,21-77.6,87.8-81.8l92.2-4.3l4.1-0.2l4-0.1V393.7z M465.9,422.9c-3-10-11.3-16.1-21.4-16.1c-2.7,0.1-5.2,0.3-8.4,1
                c-14.3,3.4-22.2,4.5-33.2,5.3c-20.9,1-24.6-7.1-25.9-30.6V61.4c-0.6-7.4-4.5-14.8-10.2-19.3l-2.1-1.3c-0.7-0.5-1.3-1.2-2.2-1.6
                C345,28.9,316,20.6,291.4,14.4l-1.8-0.5C260.3,6.8,228,3.1,196,3.1c-18.8,0-35.7,1.4-42.5,2.3c-14.1,1.4-52,7.7-64.7,12
                c-3.7,1.2-15.7,6.9-16.1,18.2c0.2,5.9,6.8,24.6,6.8,24.6c4.3,13.1,8.9,16.3,17.2,18c6.7,0.8,21-2.3,30.6-3.9
                c24.7-4.6,40.9-6.3,52.5-6.4c15-0.2,33.8-0.4,55.9,2.7c41.9,6.4,58.1,19.3,58.1,19.3v124.7l-3.7,0.1l-89.6,2.2
                C80.8,220.8,25.3,268.3,26.1,364c-0.2,43.5,13.4,78.3,39.4,100.9c24.1,21.2,59.5,32.3,102,32.3h0.2c48.8,0,90.9-15.1,131.8-47.5
                l3.9-3l2,4.5c9.8,21.7,26.6,35.7,49.7,41.6c10.3,2.9,22.1,4.4,37.2,4.4c3.9,0,7.8-0.2,11.2-0.6c13.7-1.9,31.9-4.3,52.1-13.9
                c11.1-5.3,19-11.8,18.4-23.5C473.6,448.9,465.9,422.9,465.9,422.9"/>
            </svg>
            <svg className="mt-24 ml-32" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 500 500" fill="none" >
            <path className={`fill-white`} d="M297.9,393.7l-1.6,1.2l-1.7,1c-29.8,20.6-74.3,34.4-110.8,34.4h0c-53.5-1.2-73-20.1-74.1-71.6
                c1.2-59.3,21-77.6,87.8-81.8l92.2-4.3l4.1-0.2l4-0.1V393.7z M465.9,422.9c-3-10-11.3-16.1-21.4-16.1c-2.7,0.1-5.2,0.3-8.4,1
                c-14.3,3.4-22.2,4.5-33.2,5.3c-20.9,1-24.6-7.1-25.9-30.6V61.4c-0.6-7.4-4.5-14.8-10.2-19.3l-2.1-1.3c-0.7-0.5-1.3-1.2-2.2-1.6
                C345,28.9,316,20.6,291.4,14.4l-1.8-0.5C260.3,6.8,228,3.1,196,3.1c-18.8,0-35.7,1.4-42.5,2.3c-14.1,1.4-52,7.7-64.7,12
                c-3.7,1.2-15.7,6.9-16.1,18.2c0.2,5.9,6.8,24.6,6.8,24.6c4.3,13.1,8.9,16.3,17.2,18c6.7,0.8,21-2.3,30.6-3.9
                c24.7-4.6,40.9-6.3,52.5-6.4c15-0.2,33.8-0.4,55.9,2.7c41.9,6.4,58.1,19.3,58.1,19.3v124.7l-3.7,0.1l-89.6,2.2
                C80.8,220.8,25.3,268.3,26.1,364c-0.2,43.5,13.4,78.3,39.4,100.9c24.1,21.2,59.5,32.3,102,32.3h0.2c48.8,0,90.9-15.1,131.8-47.5
                l3.9-3l2,4.5c9.8,21.7,26.6,35.7,49.7,41.6c10.3,2.9,22.1,4.4,37.2,4.4c3.9,0,7.8-0.2,11.2-0.6c13.7-1.9,31.9-4.3,52.1-13.9
                c11.1-5.3,19-11.8,18.4-23.5C473.6,448.9,465.9,422.9,465.9,422.9"/>
            </svg>
        </div>
    }
    
    return (
        <div className="bg-white overflow-hidden">
            <div className={`grid w-full`} style={{height : small ? 400 : 520}}>
                {gatsbyImage ? 
                    <GatsbyImage image={gatsbyImage}
                        style={{gridArea: '1/1', height : small ? 360 : 480}}
                        className={`bg-cover bg-center z-10`}
                    />
                :   <div
                    style={{gridArea: '1/1', backgroundImage: `url(${image})`, height : small ? 360 : 480}}
                    className={`bg-cover bg-center z-10`}
                />}
                <div
                    className="z-10"
                    style={{
                    gridArea: "1/1",
                    position: "relative",
                    placeItems: "center",
                    display: "grid",
                    }}>
                    <div className="w-full h-full flex justify-center items-center z-0"
                        style={{
                            opacity: 0.75,
                            background: "var(--global-gradient, linear-gradient(180deg, #000 0%, rgba(0, 0, 56, 0.00) 100%, rgba(0, 0, 2, 0.00) 100%))"
                        }}
                    >
                    </div>
                    <div style={{
                        background: "var(--global-gradient, linear-gradient(90deg, #000 0%, rgba(0, 0, 56, 0.00) 100%, rgba(0, 0, 2, 0.00) 100%))",
                        opacity: 0.25,
                        height : small ? 360 : 480
                    }} 
                        className="w-[400px] absolute left-0 top-0"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="400" height={small ? 360 : 480} viewBox={small ? "0 0 400 360" : "0 0 400 480"} fill="none">
                            <path opacity="0.25" d="M1.04907e-05 0L0 480L400 480V3.49691e-05L1.04907e-05 0Z" fill="url(#paint0_linear_851_4981)"/>
                            <defs>
                                <linearGradient id="paint0_linear_851_4981" x1="2.98023e-06" y1="240" x2="400" y2="240" gradientUnits="userSpaceOnUse">
                                <stop/>
                                <stop offset="1" stopColor="#000038" stopOpacity="0"/>
                                <stop offset="1" stopColor="#000002" stopOpacity="0"/>
                                </linearGradient>
                            </defs>
                            </svg>
                    </div>
                    <div style={{
                        fill: "var(--global-gradient, linear-gradient(270deg, #000 0%, rgba(0, 0, 56, 0.00) 100%, rgba(0, 0, 2, 0.00) 100%))",
                        opacity: 0.5,
                        height : small ? 360 : 480
                    }} 
                        className="w-[400px] absolute right-0 top-0"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="400" height={small ? 360 : 480} viewBox={small ? "0 0 400 360" : "0 0 400 480"} fill="none">
                        <path opacity="0.5" d="M400 0V480L1.04907e-05 480L0 3.49691e-05L400 0Z" fill="url(#paint0_linear_851_4982)"/>
                        <defs>
                            <linearGradient id="paint0_linear_851_4982" x1="400" y1="240" x2="1.00136e-05" y2="240" gradientUnits="userSpaceOnUse">
                            <stop/>
                            <stop offset="1" stopColor="#000038" stopOpacity="0"/>
                            <stop offset="1" stopColor="#000002" stopOpacity="0"/>
                            </linearGradient>
                        </defs>
                        </svg>
                    </div>
                </div>
                <div 
                className="z-20"
                style={{
                gridArea: "1/1",
                position: "relative",
                placeItems: "center",
                display: "grid",
                }}>
                <div className={`${small ? 'w-10/12' : 'md:w-[763px]'} mt-[140px] items-center justify-center z-20`} >
                    {backLabel && backLink ? 
                    <div className="mb-2 -mt-8">
                        <a className="flex space-x-2 justify-center" onClick={() => navigate(backLink)} href="#">
                            <div className="h-[22px] w-[22px]"> 
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                    <path fillRule="evenodd" clipRule="evenodd" d="M11 0L0 11L11 22L12 21L2 11L12 1L11 0ZM21 0L10 11L21 22L22 21L12 11L22 1L21 0Z" fill="white"/>
                                </svg>
                            </div>
                            <div className="text-white font-title font-[30px]">{backLabel}</div>
                        </a>
                    </div>
                    : null}
                    <h1 className="text-4xl sm:text-5xl lg:text-7xl font-semibold font-title text-white text-center leading-tight">
                    {title}
                    </h1>
                </div>
            </div>
        </div>
        <div className="relative list-item flex-1 justify-end z-10">
            <div className="hidden md:block absolute right-32  -top-20">
                <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
                    <circle cx="40" cy="40" r="40" fill="white"/>
                </svg>
            </div>
            <div className="hidden md:block absolute right-52 -top-32">
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
                    <circle opacity="1" cx="20" cy="20" r="20" className={`${colourVariants['fill500'][accentColour || 'blue']}`}/>
                </svg>
            </div>
            <div className={`z-10 absolute rounded-full -left-24 md:-left-12 -top-[350px] w-[180px] h-[180px] md:w-[360px] md:h-[360px] border-[1.5px] border-solid ${colourVariants['border'][accentColour || 'orange']}`}></div>     
            {iconAccent ? accentIcons[iconAccent] : <div className={`z-10 absolute rounded-full left-12 md:left-56 -top-[350px] w-[80px] h-[80px] border-[1.5px] border-solid border-orange-500`}></div>}
        </div>
    </div>
    )
}

MainPageHeader.propTypes = {
    title: PropTypes.any.isRequired,
    image: PropTypes.string.isRequired,
    backLink: PropTypes.any,
    backLabel: PropTypes.string
}